









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroPlayerDocument } from "@/services/datatypes";
import { db, firestore } from "@/scripts/firebase";
import { collectionName } from "../../../services/collection-name";
import { ToastProgrammatic as Toast } from "buefy";
import { TOAST_DURATION_MILLISECONDS } from "@/services/constants";
import { DialogProgrammatic as Dialog } from "buefy";

@Component({
  components: {}
})
export default class DeleteJinroPlayer extends Vue {
  @Prop() readonly jinroRoomTitle!: string;
  @Prop() readonly jinroRoomId!: string;

  get jinroPlayer(): JinroPlayerDocument | null {
    if (!this.$store.state.jinroPlayer) {
      return null;
    }

    return this.$store.state.jinroPlayer;
  }

  handleDelete() {
    if (!this.jinroPlayer) {
      return;
    }
    const jinroPlayer = this.jinroPlayer;
    Dialog.confirm({
      message: `「${this.jinroRoomTitle}」から本当に抜けますか?   参加プレイヤーから「${jinroPlayer.playerName}」を削除しますが、ランキングなどの情報には残り続けます。`,
      type: "is-danger",
      cancelText: "キャンセル",
      confirmText: "ゲームから抜ける",
      onConfirm: async () =>
        this.deletePlayer(jinroPlayer.id, jinroPlayer.playerName)
    });
  }

  async deletePlayer(playerId: string, playerName: string) {
    await db
      .collection(collectionName.jinrorooms)
      .doc(this.jinroRoomId)
      .collection(collectionName.jinroplayers)
      .doc(playerId)
      .set(
        {
          isDeleted: true,
          timeUpdated: firestore.FieldValue.serverTimestamp()
        },
        { merge: true }
      );

    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      type: "is-info",
      queue: false,
      message: `「${playerName}」が参加プレイヤーから削除されました。`
    });
    this.$router.push(`/j/${this.jinroRoomId}`);
  }
}
